<template>
	<div class="body">
		<div class="body-container">
			<el-table :data="list" :span-method="spanMethod" border stripe>
				<el-table-column label="行业（专业）" align="center" prop="industryMajor">
					<template v-slot="{ row }">
						<div class="custom-wrap">{{formatWithLineBreaks(row.industryMajor)}}</div>
					</template>
				</el-table-column>
				<el-table-column label="对应职业" align="center" prop="career_name">
					<template v-slot="{ row }">
						<label>{{row.career_name}}</label>
					</template>
				</el-table-column>
				<el-table-column label="职业编码" align="center" prop="career_name">
					<template v-slot="{ row }">
						<label>{{row.career_code}}</label>
					</template>
				</el-table-column>
				<el-table-column label="能力简介" align="center" prop="career_name">
					<template v-slot="{ row }">
						<label @click="clickIntro(row.career_code)"
							class="el-button el-button--small el-button--primary">查看</label>
					</template>
				</el-table-column>
				<el-table-column label="状态" align="center" prop="career_name">
					<template v-slot="{ row }">
						<label v-if="acceptMap[row.career_code]"
							:style="acceptMap[row.career_code] == 1 ? 'color:green' : 'color:red' ">{{acceptMap[row.career_code] == 1 ? '符合要求' : '不符合要求'}}</label>
						<label @click="clickIntro(row.career_code)" v-else style="color: blue;">待选择</label>
					</template>
				</el-table-column>
				<el-table-column label="职业标准" align="center" prop="career_name">
					<template v-slot="{ row }">
						<label v-if="row.hasStandard == 1" @click="clickStandard(row.career_code)"
							class="el-button el-button--small">查看</label>
						<label v-else>-</label>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<pagination v-show="total>0" :total="total" :page.sync="params.page" :limit.sync="params.pageSize"
					@pagination="requestData(true)" />
			</div>
		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>

		<el-dialog :title="careerData.title" :visible.sync="showCareerDialog" append-to-body v-if="showCareerDialog"
			align="center">

			<div class="dialog-content">{{formatTextWithLineBreaks(careerData.content)}}</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickAccept(careerData)">符合要求</el-button>
				<el-button type="primary" class="el-button--warning" @click="clickReject(careerData)">不符合要求</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="detailTitle" :visible.sync="showDetailDialog" append-to-body v-if="showDetailDialog"
			align="center" width="70%">
			<el-form :inline="true" style="display: flex;flex-direction: row;">
				<el-form-item label="等级">
					<el-select class="select-width" v-model="level" >
						<el-option v-for="item in levelList" :key="item.level" :label="item.name" :value="item.level">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" icon="el-icon-search" size="medium" @click="queryStandard">确定</el-button>
				</el-form-item>

			</el-form>
			<el-table :data="standardList" border stripe :span-method="standardSpanMethod">
				<el-table-column label="职业功能" align="center" prop="position">
				</el-table-column>
				<el-table-column label="工作内容" align="center" prop="work">
				</el-table-column>
				<el-table-column label="技能要求" align="left" prop="content">
					<template v-slot="{ row }">
						<div class="wrap-content">{{formatTextWithLineBreaks(row.skill)}}</div>
					</template>
				</el-table-column>

				<el-table-column label="相关知识要求" align="left" prop="content">
					<template v-slot="{ row }">
						<div class="wrap-content">{{formatTextWithLineBreaks(row.knowledge)}}</div>
					</template>
				</el-table-column>
			</el-table>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" class="el-button--warning" @click="clickCloseDetail()">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		calcuGroupIndustryCareer,
		queryCareerContent,
		getCareerLevelStandard,
		queryStandardLevelList
	} from "@/api/matrix"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				list: [],
				spanMap: {},
				standardSpanMap: {},
				params: {
					page: 1,
					pageSize: 20
				},
				total: 0,
				careerData: {},
				showCareerDialog: false,
				acceptMap: {},
				detailTitle: '',
				showDetailDialog: false,
				standardList: [],
				levelList: [],
				level: 1,
				code: ''
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.requestData(false);
			},

			requestData(fromPage=false) {
				this.groupId = this.$route.query.id;
				this.codes = this.$route.query.codes;
				this.params['group_id'] = this.groupId;
				this.params['codes'] = this.codes;
				calcuGroupIndustryCareer(this.params).then(res => {
					let realData = res.data;
					this.list = realData.list;
					this.total = realData.pageData.totalCount;
					if(!fromPage){
						this.acceptMap = realData.selectedMap;
					}
				
					this.spanMap = getSpanMap(this.list, ['industryMajor'])
				});
			},

			clickNext() {
				let codeList = this.getSelectedCodes()

				if (codeList.length < 1) {
					Message({
						message: '职业为空',
						type: 'error',
						zIndex: 3000
					})
					return;
				}

				let path = '/career_job?id=' + this.groupId + '&career_codes=' + codeList.join();
				console.log('path', path)
				this.$router.push(path);
			},

			spanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.spanMap[colProp]) {
					const rowspan = this.spanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},

			standardSpanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.standardSpanMap[colProp]) {
					const rowspan = this.standardSpanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},

			formatWithLineBreaks(text) {
				if (!text) return '';

				return text.replace(/;/g, '，\n\n');
			},

			// 方法：格式化文本
			formatTextWithLineBreaks(text) {
				return text.split(';')
					.map(line => line.trim())
					.filter(line => line !== '')
					.join(';\n');
			},

			clickIntro(code) {
				queryCareerContent({
					code: code
				}).then(res => {
					console.log('groupId', this.groupId)
					let realData = res.data;
					this.showCareerDialog = true;
					this.careerData = realData.data;
				});
			},

			clickAccept(careerData) {
				this.showCareerDialog = false;
				this.$set(this.acceptMap, careerData.code, 1)
				console.log('this.acceptMap', this.acceptMap)
			},

			clickReject(careerData) {
				this.showCareerDialog = false;
				this.$set(this.acceptMap, careerData.code, 2)
			},

			getSelectedCodes() {
				let list = []

				Object.keys(this.acceptMap).forEach(key => {
					if (this.acceptMap[key] == 1) {
						list.push(key)
					}
				})

				return list;
			},

			clickStandard(code) {
				this.code = code;
				let params = {
					'code': code,
				}
				queryStandardLevelList(params).then(res => {
					let realData = res.data;

					this.showDetailDialog = true;
					this.levelList = realData.list;
					if (this.levelList && this.levelList.length > 0){
						this.level = this.levelList[0]['level']
						this.queryStandard();
					}
				})
			},
			
			queryStandard(){
				let params = {
					'code': this.code,
					'level': this.level
				}
				
				getCareerLevelStandard(params).then(res => {
					let realData = res.data;
				
					this.detailTitle = realData.title;
					this.standardList = realData.list;
				
					this.standardSpanMap = getSpanMap(this.standardList, ['position'])
				})
				
			},

			clickCloseDetail() {
				this.standardList = [];
				this.showDetailDialog = false;
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "industry_career.scss";
</style>